module.exports = __webpack_public_path__ + "img/AllAroundWorlds.5e8f2c91.jpg";